<template>
    <div class="global-modals">
        <ui-create-deal-modal name="create-deal-modal" :closed-option="closedOptions"/>
        <ui-create-task-modal name="global--create-task" :show-close-option="false" :custom-close-event="['custom-close-select-reserve', 'custom-close-create-deal']" />
        <ui-select-reserve-modal name="global--request-reserve" custom-close-event="custom-close-create-deal" />
    </div>
</template>

<script>
	import uiCreateDealModal from '../create-deal-modal'
	import uiCreateTaskModal from '../create-task-modal'
	import uiSelectReserveModal from '../select-reserve-modal'

	export default {
		name: 'ui-global-modals',
		components: {
			uiCreateDealModal,
			uiCreateTaskModal,
			uiSelectReserveModal,
		},
		props: {
			closedOptions: {
				type: Boolean,
				default: false
			}
		},
	}
</script>
